import React from 'react'
import {
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Paragraph,
  Button,
  DangerButton,
  Separator,
} from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'
import { ContentDelete } from '@fs/zion-icon'
import { getPersonName } from '@fs/zion-sls'
import { useFamilyReviewStateContext } from '../../providers/FamilyReviewContext'

export default function ConfirmRemoveOverlay({
  confirmRemoveOverlay,
  currentTask,
  handleNotAPerson,
  removePerson,
  setRelationshipAsOther,
}) {
  const [t] = useTranslation()
  const state = useFamilyReviewStateContext()
  const currentPerson = currentTask?.subElements.find((el) => el?.id === state.selectedPersonId)
  const currentPersonName = getPersonName({ person: currentPerson, justOneName: true })

  return (
    <DialogOverlay {...confirmRemoveOverlay} title={t('confirm-remove-overlay.title', 'Are you sure?')} size="lg">
      <Trans i18nKey="confirm-remove-overlay.body-1">
        <Paragraph>
          If the document includes <em>{currentPersonName}</em> in the record, then mark the Relationship as{' '}
          <strong>No Direct Relation</strong>.
        </Paragraph>
      </Trans>
      <Trans i18nKey="confirm-remove-overlay.body-2">
        <Paragraph>
          Otherwise, <strong>Remove</strong> <em>{currentPersonName}</em> from the record.
        </Paragraph>
      </Trans>
      <Separator size="xs" />
      <Trans i18nKey="confirm-remove-overlay.body-3">
        <Paragraph>
          If this isn&apos;t a name at all, mark as{' '}
          <Button
            linkName="Confirm Remove Overlay Not A Person"
            onClick={handleNotAPerson}
            data-testid="not-a-person-button"
            text={t('confirm-remove-overlay.not-a-person-button', 'Not a person')}
            dense
          >
            {t('confirm-remove-overlay.not-a-person-button', 'Not a person')}
          </Button>
          .
        </Paragraph>
      </Trans>
      <Separator size="xs" />
      <Trans i18nKey="confirm-remove-overlay.body-4">
        <Paragraph>Please confirm this change.</Paragraph>
      </Trans>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <DangerButton
            onClick={removePerson}
            Icon={ContentDelete}
            data-testid="confirm-remove-button"
            linkName="Confirm Remove Submit"
          >
            {t('confirm-remove-overlay.remove-button', 'Remove from record')}
          </DangerButton>

          <Button
            onClick={setRelationshipAsOther}
            emphasis="medium"
            data-testid="relationship-as-other-button"
            linkName="Confirm Remove Relationship as Other"
          >
            {t('confirm-remove-overlay.no-direct-relation-button', 'Relationship as No Direct Relation')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
